// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {

	$w("#faqContainer").onClick((event) => {
		let $item = $w.at(event.context);

		if ($item("#answer").collapsed) {
			$item("#answer").expand();
			$item("#buttonCollapse").expand();
			$item("#buttonExpand").collapse();
		} else {
			$item("#answer").collapse();
			$item("#buttonCollapse").collapse();
			$item("#buttonExpand").expand();
		}
	});
});